import { Layers, RefreshCw, Lock, ArrowUpRight } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const OpenPlatformsSection = () => {
  const { t } = useLanguage();

  const platforms = [
    {
      title: t('platforms.ownPlatform'),
      description: t('platforms.ownPlatformDesc'),
      icon: Layers,
    },
    {
      title: t('platforms.partnerPlatforms'),
      description: t('platforms.partnerPlatformsDesc'),
      icon: RefreshCw,
    },
    {
      title: t('platforms.thirdParty'),
      description: t('platforms.thirdPartyDesc'),
      icon: ArrowUpRight,
    },
  ];

  return (
    <section className="py-20 md:py-32 bg-white" data-testid="platforms-section">
      <div className="container-0g">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <p className="section-label">{t('platforms.label')}</p>
            <h2 className="section-title mb-6">{t('platforms.title')}</h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              {t('platforms.subtitle')}
            </p>

            {/* No vendor lock-in badge */}
            <div className="inline-flex items-center space-x-2 bg-teal-600/10 border border-teal-600/20 px-4 py-2 rounded-sm mb-8">
              <Lock className="h-4 w-4 text-teal-600" />
              <span className="text-sm font-medium text-teal-700">{t('platforms.noLockIn')}</span>
            </div>
          </div>

          {/* Platform cards */}
          <div className="space-y-4">
            {platforms.map((platform, index) => {
              const Icon = platform.icon;
              return (
                <div
                  key={index}
                  className="flex items-start space-x-4 p-6 bg-white border border-slate-200 rounded-sm hover:border-teal-500 transition-colors"
                  data-testid={`platform-${index}`}
                >
                  <div className="w-12 h-12 rounded-sm bg-slate-100 flex items-center justify-center flex-shrink-0">
                    <Icon className="h-6 w-6 text-teal-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">{platform.title}</h3>
                    <p className="text-sm text-slate-600">{platform.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
